import { GEO_TYPES } from 'helpers/chartHelper';
import { OrderedColumnsT } from 'business/definitions';
import { getBestSuitableRemainingColumn } from './helpers';

/**
 * Finds the first column in the array that has a type of either polygon or coordinates.
 */
const findGeoTypeColumn = (columns: ResponseColumnT[]) => {
    return columns.find((col) => GEO_TYPES.includes(col.type));
};

/**
 * Finds the ordered columns of a map visualization.
 * It makes sure to put a geo type column on x, a metric on y and the most relevant remaining column on z.
 */
export const getMapVizOrderedColumns = (
    chartColumns: ResponseColumnT[],
    metricColumn: ResponseColumnT,
): OrderedColumnsT => {
    const geoTypeColumn = findGeoTypeColumn(chartColumns);
    if (!geoTypeColumn)
        return {
            y: metricColumn,
        };
    return {
        x: geoTypeColumn,
        y: metricColumn,
        z: getBestSuitableRemainingColumn(chartColumns, [
            metricColumn.key,
            geoTypeColumn?.key,
        ]),
    };
};
